/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface InscriptionMasseSearch
 */
export interface InscriptionMasseSearch {
    /**
     * 
     * @type {number}
     * @memberof InscriptionMasseSearch
     */
    idcentre?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionMasseSearch
     */
    idclasseSelected?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof InscriptionMasseSearch
     */
    alreadyInClasseIds?: Array<number> | null;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    degres?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    idsclasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    masculins?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    classes?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    anneesScolaires?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    deliberations?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    deliberations2sess?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof InscriptionMasseSearch
     */
    codesMetier?: TextSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof InscriptionMasseSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof InscriptionMasseSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InscriptionMasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof InscriptionMasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionMasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionMasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof InscriptionMasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof InscriptionMasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the InscriptionMasseSearch interface.
 */
export function instanceOfInscriptionMasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionMasseSearchFromJSON(json: any): InscriptionMasseSearch {
    return InscriptionMasseSearchFromJSONTyped(json, false);
}

export function InscriptionMasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionMasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'idclasseSelected': !exists(json, 'idclasseSelected') ? undefined : json['idclasseSelected'],
        'alreadyInClasseIds': !exists(json, 'alreadyInClasseIds') ? undefined : json['alreadyInClasseIds'],
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'degres': !exists(json, 'degres') ? undefined : TextSearchFromJSON(json['degres']),
        'idsclasse': !exists(json, 'idsclasse') ? undefined : TextSearchFromJSON(json['idsclasse']),
        'masculins': !exists(json, 'masculins') ? undefined : TextSearchFromJSON(json['masculins']),
        'classes': !exists(json, 'classes') ? undefined : TextSearchFromJSON(json['classes']),
        'anneesScolaires': !exists(json, 'anneesScolaires') ? undefined : TextSearchFromJSON(json['anneesScolaires']),
        'deliberations': !exists(json, 'deliberations') ? undefined : TextSearchFromJSON(json['deliberations']),
        'deliberations2sess': !exists(json, 'deliberations2sess') ? undefined : TextSearchFromJSON(json['deliberations2sess']),
        'codesMetier': !exists(json, 'codesMetier') ? undefined : TextSearchFromJSON(json['codesMetier']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function InscriptionMasseSearchToJSON(value?: InscriptionMasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcentre': value.idcentre,
        'idclasseSelected': value.idclasseSelected,
        'alreadyInClasseIds': value.alreadyInClasseIds,
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'degres': TextSearchToJSON(value.degres),
        'idsclasse': TextSearchToJSON(value.idsclasse),
        'masculins': TextSearchToJSON(value.masculins),
        'classes': TextSearchToJSON(value.classes),
        'anneesScolaires': TextSearchToJSON(value.anneesScolaires),
        'deliberations': TextSearchToJSON(value.deliberations),
        'deliberations2sess': TextSearchToJSON(value.deliberations2sess),
        'codesMetier': TextSearchToJSON(value.codesMetier),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

